export default "__VITE_ASSET__Cikej2dV__"